module Clerk where

import Prelude

import Data.Maybe (Maybe)
import Data.Nullable (Nullable)
import Data.Nullable as Nullable
import Effect (Effect)
import Effect.Aff (Aff)
import Effect.Class (liftEffect)
import Promise (Promise)
import Promise.Aff as Promise
import Web.HTML (HTMLElement)

foreign import data Clerk :: Type
foreign import data User :: Type
foreign import data Session :: Type

foreign import _createClerk :: Effect Clerk

foreign import _load :: Clerk -> Effect (Promise Unit)

foreign import _getSession :: Clerk -> Effect (Nullable Session)

foreign import _getToken :: Session -> Effect (Promise String)

foreign import _getUser :: Clerk -> Effect (Nullable User)

foreign import _mountSignIn :: HTMLElement -> Clerk -> Effect Unit

foreign import _openSignIn :: Clerk -> Effect Unit

foreign import _openUserProfile :: Clerk -> Effect Unit

foreign import _mountUserButton :: HTMLElement -> Clerk -> Effect Unit

foreign import _mountUserProfile :: HTMLElement -> Clerk -> Effect Unit

foreign import _getUserName :: User -> String

foreign import _getUserId :: User -> String

foreign import _getImageUrl :: User -> String

foreign import _signOut :: Clerk -> Effect (Promise Unit)

initClerk ∷ Aff Clerk
initClerk = do
  c <- liftEffect _createClerk
  void $ Promise.toAffE $ _load c
  pure c

getSession :: Clerk -> Effect (Maybe Session)
getSession c = Nullable.toMaybe <$> _getSession c

getToken :: Session -> Aff String
getToken session = Promise.toAffE $ _getToken session

getUser :: Clerk -> Effect (Maybe User)
getUser c = Nullable.toMaybe <$> _getUser c

userUserId :: User -> String
userUserId = _getUserId

mountSignIn :: HTMLElement -> Clerk -> Effect Unit
mountSignIn = _mountSignIn

mountUserButton :: HTMLElement -> Clerk -> Effect Unit
mountUserButton = _mountUserButton

mountUserProfile :: HTMLElement -> Clerk -> Effect Unit
mountUserProfile = _mountUserProfile

openSignIn :: Clerk -> Effect Unit
openSignIn = _openSignIn

openUserProfile :: Clerk -> Effect Unit
openUserProfile = _openUserProfile

signOut :: Clerk -> Aff Unit
signOut c = Promise.toAffE $ _signOut c

userUserName :: User -> String
userUserName = _getUserName

userImageUrl :: User -> String
userImageUrl = _getImageUrl
